// global/lib

$(document).ready(function () {
    initEventChangeLanguage();
    initEventsVideosThumb();
    initEventsMenu();
    window.history.replaceState({}, '', removeParam('r', window.location.href));
});

function initEventsMenu() {
    $(".btn-menu").click(function () {
        //if search is shown
        if ($('body').hasClass('mobile-search-on')) {
            $(".left-menu").removeClass('closing');
            //toggle class search
            $('body').toggleClass('mobile-search-on');
            //hide menu search and change icon back to search icon
            $(".search--navigation").toggleClass('visible');
            $('.magnifier-icon').toggleClass('is-open');
            //Add clase to left-menu
            $(".left-menu").toggleClass('is-active');
            mostrarMenu();
            $(".btn-menu").toggleClass('is-active');
            $('body').toggleClass('menu-active');
        }
        //if search is closed
        else {
            if ($('.left-menu').hasClass("is-active")) {
                ocultarMenu();
            } else {
                mostrarMenu();
            }
        }
        return false;
    });

    $('.left-menu .dark-halo').click(function () {
        ocultarMenu()
    });
}

const $body = document.querySelector('body');
var scrollPosition = 0;

function enableMenuScroll() {
    scrollPosition = window.pageYOffset;
    $body.style.overflow = 'hidden';
    $body.style.position = 'fixed';
    $body.style.top = '-' + scrollPosition + 'px';
    $body.style.width = '100%';
}

function disableMenuScroll() {
    $body.style.removeProperty('overflow');
    $body.style.removeProperty('position');
    $body.style.removeProperty('top');
    $body.style.removeProperty('width');
    window.scrollTo(0, scrollPosition);
}

function mostrarMenu() {
    if ($(window).width() < 760) {
        enableMenuScroll()

    }

    $(".btn-menu").addClass('is-active');
    $(".left-menu").addClass('is-active');
    $('body').addClass('menu-active');


}

function ocultarMenu() {
    if ($(window).width() < 760) {
        disableMenuScroll();
    }

    $(".btn-menu").removeClass('is-active');
    $(".left-menu").removeClass('is-active');
    $(".left-menu").addClass('closing');
    $('body').removeClass('menu-active');

    setTimeout(function () {
        $(".left-menu").removeClass('closing');
    }, 400);

}

$(window).on('resize', function () {

    //remove fixed scroll thumbs from 760px & beyond
    if ($(window).width() > 768) {

        if ($(".btn-menu").hasClass("is-active")) {
            scrollPosition = window.pageYOffset;
            disableMenuScroll();
        }
    }
});


/*function addMenuOverlay() {
    $('#menu-bg-overlay').remove();

    $('body').append(
        $('<div>', {
            'id': 'menu-bg-overlay',
        }).click(function () {
            //hide menu, remove class is-active anc change icon back to burguer
            ocultarMenu();
            $(".btn-menu").toggleClass('is-active');
            $(".left-menu").toggleClass('is-active');
        })
    );

    $('#menu-bg-overlay').fadeIn(100);
}*/

function addErrorMsg(id, msg) {
    $(id).closest("[add-error-here='1']").addClass('error-input');

    if (msg != null) {
        var msgObj = $(id).closest("[add-error-here='1']").find('small.msg-error').first();

        if (!$(msgObj).length) {
            // lo creamos
            $(id).closest("[add-error-here='1']").append(
                $('<small>', {
                    class: 'msg-error',
                    html: msg
                })
            );
        } else {
            $(msgObj).html(msg);
        }

        $(msgObj).show();
    }
}

function removeError(id) {
    $(id).closest("[add-error-here='1']").removeClass('error-input');
    $(id).closest("[add-error-here='1']").find('small.msg-error').remove();
}

function removeErrors(id) {
    $('#' + id + ' [add-error-here]').removeClass('error-input');
    $('#' + id + ' small.msg-error').remove();
}

function alertWeb(message, type) {
    var classes = 'alert alert-dismissible fade in';
    var icon = 'icono';

    switch (type) {
        case 'success':
            classes = classes + ' alert-success';
            icon = icon + ' icon-ok-circled';
            break;
        case 'warning':
            classes = classes + ' alert-warning';
            icon = icon + ' icon-attention-1';
            break;
        case 'error':
            classes = classes + ' alert-error';
            icon = icon + ' icon-error-alt';
            break;
        default:
            return;
    }

    $('body > div.alert:first-child').remove();
    $('body').prepend(
        $('<div>', {
            'class': classes,
            'role': 'alert'
        }).append(
            $('<button>', {
                'type': 'button',
                'class': 'close',
                'data-dismiss': 'alert',
                'arial-label': 'Close'
            }).append(
                $('<span>', {
                    'aria-hidden': 'true',
                }).html('&times;')
            )
        ).append(
            $('<i>', {
                'class': icon,
            })
        ).append(' ' + message)
    );

    $('.alert-dismissible .close').click(function (event) {
        $('body > div.alert:first-child').remove();
    });
}

function showLoginRegistrarModal() {
    $('#loginprompt').remodal().open();
}

function showConfirmDeleteModal() {
    $('#confirmdelete').remodal().open();
}

function initEventChangeLanguage() {
    $(window).click(function () {
        $('.footer .locale-page-info').hide();
    });

    $('.footer .btn-lenguage-footer').click(function (event) {
        $('.footer .locale-page-info').toggle();
        event.stopPropagation();
        return false;
    });

    $('.locale-page-info a[rel="alternate"]').click(function (e) {
        e.preventDefault();

        Cookies.set('lang', $(this).data('locale'), {
            expires: 365 * 100,
            domain: global_tokyvideo_cookie_lang_domain,
            path: '/',
            sameSite: 'none',
            secure: true
        });

        window.location.href = this.href;
    });
}

function initEventsVideosThumb() {
    $('.listado-videos .thumb-video, .related-videos .thumb-video').each(function (index, element) {
        initEventsVideoThumb(element);
    });
    initEventVideoThumbBan();
}

function initEventsVideoThumb(video) {
    initEventVideoThumbViewLater(video);
    initEventHighlight(video);

    return video;
}

function initEventVideoThumbViewLater(video) {
    $(video).find('.view-later.view-later-real').click(function () {
        if (global_tokyvideo_guest) {
            showLoginRegistrarModal();
        } else {
            var viewLaterObj = this;
            var apiUrl = $(viewLaterObj).data('api-url');

            $.post(apiUrl, {
                'add': $(viewLaterObj).hasClass('view-later-added') ? 0 : 1
            },
                function (response) {
                    if ((response['error'] == true) && (response['alert'] == true)) {
                        alertWeb(response['message'], response['message_type']);
                    } else if (response['result'] == 'ok') {
                        if (response['actionAdd']) {
                            $('.view-later.view-later-real[data-api-url="' + apiUrl + '"]').addClass('view-later-added');
                        } else {
                            $('.view-later.view-later-real[data-api-url="' + apiUrl + '"]').removeClass('view-later-added');
                        }
                    }
                },
                'json'
            );
        }

        return false;
    });
}

function initEventVideoThumbBan() {
    $('#confirmban #confirmban-cancel').click(function () {
        $('#confirmban').remodal().close();
        return false;
    });

    $('#confirmban #confirmban-yes').click(function () {
        eventVideoThumbBan();
        $('#confirmban').remodal().close();
        return false;
    });

    $('.admin-video-ban').click(function () {
        $('#confirmban').data('confirm-url', $(this).data('api-url'));
        text = $(this).hasClass('admin-video-unban') ? 'desbanear' : 'banear';
        $('#confirmban-name').html('Vas a ' + text + ': <strong>' + $(this).closest('.thumb-video').find('h3').find('a').text() + '</strong>');
        $('#confirmban').remodal().open();
        return false;
    });
}

function eventVideoThumbBan() {

    $trigger = $('[data-api-url="' + $('#confirmban').data('confirm-url') + '"]');
    $.post($trigger.data('api-url'), {
        'ban': $trigger.eq(0).hasClass('admin-video-unban') ? 0 : 1
    },
        function (response) {
            if ((response['error'] == true) && (response['alert'] == true)) {
                alertWeb(response['message'], response['message_type']);
            } else if (response['result'] == 'ok') {
                $trigger.toggleClass('admin-video-unban');
                $trigger.closest('.thumb-video').toggleClass('banned-video');
            }
        },
        'json'
    );

    return false;
}

function replaceEmojis(string) {
    if (window.twemoji && BREWSER.device.desktop && BREWSER.device.os !== 'Mac OS X') {
        return twemoji.parse(string.replace('\n', '<BR />'), { folder: 'svg', ext: '.svg' });
    } else {
        var emojis = /([#0-9]\u20E3)|[\xA9\xAE\u203C\u2047-\u2049\u2122\u2139\u3030\u303D\u3297\u3299][\uFE00-\uFEFF]?|[\u2190-\u21FF][\uFE00-\uFEFF]?|[\u2300-\u23FF][\uFE00-\uFEFF]?|[\u2460-\u24FF][\uFE00-\uFEFF]?|[\u25A0-\u25FF][\uFE00-\uFEFF]?|[\u2600-\u27BF][\uFE00-\uFEFF]?|[\u2900-\u297F][\uFE00-\uFEFF]?|[\u2B00-\u2BF0][\uFE00-\uFEFF]?|(?:\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDEFF])[\uFE00-\uFEFF]?/g
        return string.replace('\n', '<BR />').replace(emojis, '<span class="icon fermoji">$&</span>');
    }
}

// very basic
function addParameterToURL(url, name, value) {
    if (url.indexOf('?') == -1) {
        var separator = '?';
    } else if (url.slice(-1) == '&') {
        var separator = '';
    } else {
        var separator = '&';
    }

    return url + separator + name + '=' + value;
}

function removeParam(key, sourceURL) {
    var rtn = sourceURL.split("?")[0],
        param,
        params_arr = [],
        queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
    if (queryString !== "") {
        params_arr = queryString.split("&");
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
            param = params_arr[i].split("=")[0];
            if (param === key) {
                params_arr.splice(i, 1);
            }
        }
        if (params_arr.length > 0) {
            rtn = rtn + "?" + params_arr.join("&");
        }
    }
    return rtn;
}